module.exports = __webpack_public_path__ + "static/4-bef837182df795283f6b4f3659f7f6be.jpg";